import { render, staticRenderFns } from "./ShortVideoItem.vue?vue&type=template&id=3bfcd6a8&scoped=true"
import script from "./ShortVideoItem.vue?vue&type=script&lang=js"
export * from "./ShortVideoItem.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoItem.vue?vue&type=style&index=0&id=3bfcd6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfcd6a8",
  null
  
)

export default component.exports